'use client'

import { cn } from '@/shared/lib/utils'

interface QuizAnswerOptionProps {
  /** Índice na lista — vira a letra (A, B, C…). */
  index: number
  label: string
  selected: boolean
  disabled?: boolean
  onSelect: () => void
}

const LETTERS = 'ABCDEFGHIJ'

/**
 * Alternativa na gramática 3D do design system: superfície com projeção
 * inferior e highlight superior, que "assenta" quando selecionada — mesma
 * mecânica do `.clickable-list-item` e do estado ativo do `ChipRail`.
 *
 * Selecionada usa utilitário de background por cima do `.clickable-list-item`:
 * utilitário do Tailwind vence `@layer components`, então o gradiente da classe
 * é sobrescrito de propósito — não é acidente de especificidade.
 */
export function QuizAnswerOption({
  index,
  label,
  selected,
  disabled,
  onSelect
}: QuizAnswerOptionProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        'clickable-list-item flex w-full items-center gap-3 text-left',
        'disabled:cursor-not-allowed disabled:opacity-60',
        selected &&
          'translate-y-px bg-jacaranda bg-none text-white shadow-[inset_0_3px_6px_rgba(0,0,0,0.30)] hover:translate-y-px'
      )}
      style={
        selected
          ? undefined
          : { boxShadow: 'var(--shadow-list-item-purple-default)' }
      }
    >
      <span
        className={cn(
          'flex size-8 shrink-0 items-center justify-center rounded-lg font-hl text-sm font-black',
          selected
            ? 'bg-white/25 text-white'
            : 'bg-white/70 text-jacaranda'
        )}
        aria-hidden
      >
        {LETTERS[index] ?? index + 1}
      </span>
      <span
        className={cn(
          'min-w-0 text-sm font-bold leading-snug',
          selected ? 'text-white' : 'text-american-blue'
        )}
      >
        {label}
      </span>
    </button>
  )
}
